export default "__VITE_ASSET___LO6eBuy__"